import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Vector3 } from 'three'
import { animated, useSpring } from 'react-spring/three'
import { useThree, useFrame } from 'react-three-fiber'

const ZoomCamera = ({
  focalPoint,
  zoom: initialZoom,
  position = [0, 0, 0],
  ...props
}) => {
  // reference to threejs perspective camera
  const camera = useRef()

  // grab function to set the default camera
  const { setDefaultCamera } = useThree()

  // spring to manage zoom and animate it
  const [{ zoom }, setZoom] = useSpring(() => ({
    zoom: initialZoom
  }))

  // update zoom when new value provided
  useEffect(() => void setZoom({ zoom: initialZoom }), [
    initialZoom,
    setZoom
  ])

  // eslint-disable-next-line
  useEffect(() => void setDefaultCamera(camera.current), [])

  // update camera when focal point changes
  useEffect(() => {
    camera.current &&
      camera.current.lookAt(new Vector3(...focalPoint))
  }, [focalPoint])

  // keep camera fixed on focal point
  useFrame(() => {
    camera.current &&
      focalPoint &&
      camera.current.lookAt(new Vector3(...focalPoint))
  })

  return (
    <animated.perspectiveCamera
      ref={camera}
      position={zoom.interpolate((val) =>
        position.map((p) => p / val)
      )}
      onUpdate={(self) => self.updateProjectionMatrix()}
      {...props}
    />
  )
}

ZoomCamera.propTypes = {
  focalPoint: PropTypes.array,
  position: PropTypes.array,
  zoom: PropTypes.number
}

export default ZoomCamera
